import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { SectionHeading } from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import { Link } from "react-router-dom";  // Import Link from react-router-dom
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Footer from "components/footers/FiveColumnWithInputForm.js";
import Light from 'components/headers/light';
import LightAdmin from 'components/headers/lightAdmin';
import ScrollToTop from "components/ScrollToTop";
import { useTranslation } from "react-i18next";

const HeaderRow = tw.div`flex justify-center items-center flex-col`;
const Header = tw(SectionHeading)``;

const TabsControl = tw.div`
  flex flex-wrap justify-center gap-3 bg-gray-100 p-4 rounded-full shadow-md mt-10
`;

const TabControl = styled.div`
  ${tw`cursor-pointer px-6 py-3 rounded-full text-base font-semibold transition duration-300 ease-in-out flex items-center gap-2`}
  background-color: ${({ active }) => (active ? "#4e7662" : "#fff")};
  color: ${({ active }) => (active ? "#fff" : "#4B5563")};
  border: 2px solid ${({ active }) => (active ? "#4e7662" : "#e5e7eb")};
  box-shadow: ${({ active }) => (active ? "0px 4px 15px rgba(0,0,0,0.1)" : "none")};
  transform: ${({ active }) => (active ? "scale(1.05)" : "scale(1)")};

  &:hover {
    background-color: #fcd6e0;
    color: #1f2937;
  }
`;
const TabContent = tw(motion.div)`mt-6 flex flex-wrap sm:-mr-10 md:-mr-6 lg:-mr-12`;
const CardContainer = tw.div`
  mt-10 w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 sm:pr-4 md:pr-4 lg:pr-6 xl:pr-6
`;
const Card = tw(motion.a)`rounded-b block max-w-xs mx-auto sm:max-w-none sm:mx-0 mb-0`;  // Add mb-0 to remove margin-bottom
const CardImageContainer = styled.div`
  ${props => css`background-image: url("${props.imageSrc}");`}
  ${tw`h-56 xl:h-64 bg-center relative rounded-t transition-transform duration-300 ease-in-out group-hover:scale-105`}
  background-size: contain;   /* ✅ Keep full image */
  background-repeat: no-repeat; /* ✅ Prevent tiling */
  background-color: #fff;      /* Optional: white background */
`;

const CardHoverOverlay = styled(motion.div)`
  background-color: rgba(255, 255, 255, 0.5);
  ${tw`absolute inset-0 flex justify-center items-center`}
`;
const CardButton = tw(PrimaryButtonBase)`
  text-sm flex justify-center items-center mt-4 rounded-full px-10 py-2
`;
const CardButtonContainer = tw.div`
  flex justify-center items-center mt-2 w-auto  /* Reduced margin */
`;
const CardText = tw.div`p-4 text-gray-900`;
const CardTitle = tw.h5`
  text-sm font-bold text-center text-[#000000]
`;

const CardContent = tw.p`
  mt-1 text-xs font-light text-center text-gray-600  /* Adjust size and font weight, and center */
`;
const CardPrice = tw.p`
mt-2 font-semibold text-center text-[#4e7662] text-[14px]
`;


const ProductTabs = ({ heading = "Nos produits",products = [] }) => {
  const role = localStorage.getItem("role"); // Assuming role is saved in localStorage
    const [cosmetique, setCosmetique] = useState([]);
  const { i18n, t } = useTranslation();

 useEffect(() => {
  fetch(`https://elanciabioapi.com/api/cosmetique?lang=${i18n.language}`)
    .then((response) => response.json())
    .then((data) => setCosmetique(Array.isArray(data) ? data : []))
    .catch((error) => console.error("Error fetching products:", error));
}, [i18n.language]); // 👈 VERY IMPORTAN

const parseJsonIfNeeded = (value) => {
  if (!value) return null;
  if (typeof value === "string") {
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }
  return value;
};

const getLangValue = (field) => {
  const parsed = parseJsonIfNeeded(field);
  if (!parsed) return "";
  if (typeof parsed === "object") {
    return parsed[i18n.language] || parsed.fr || "";
  }
  return parsed;
};

  
  return (
      <AnimationRevealPage>
                          <ScrollToTop />

          {role === "supplier" ? <Light /> : role === "buyer" ? <LightAdmin /> : <Light />}
     <Container>
      <ContentWithPaddingXl>
        <HeaderRow>
          {/* <Header>{heading}</Header> */}
        </HeaderRow>
<br/><br/>

        <TabContent>
          {cosmetique.length > 0 ? (
            cosmetique.map((card, index) => (
              <CardContainer key={index}>
                <Link to={`/product-details/${card.ProductID}`}>
                  <Card className="group" initial="rest" whileHover="hover" animate="rest">
                    <CardImageContainer imageSrc={`  https://elanciabioapi.com/storage/${card.image}`} />

                    <CardText>
                            <CardPrice>
  {role === "supplier"
    ? `${card.distributeur_price} DH`
    : `${card.user_price} DH`}
</CardPrice>
                      <CardTitle>{card.Name}</CardTitle>

                      <CardButtonContainer>
                        <CardButton>Acheter</CardButton>
                      </CardButtonContainer>
                    </CardText>
                  </Card>
                </Link>
              </CardContainer>
            ))
            
          ) : (
            <p>Aucun produit disponible.</p>
          )}
        </TabContent>
        {/* <CardButtonContainer>
  <a href="https://www.xn--lanciabio-93a.com/Boutique" style={{ textDecoration: 'none' }}>
    <CardButton>Voir Plus</CardButton>
  </a>
</CardButtonContainer> */}
      </ContentWithPaddingXl>


    </Container>
        </AnimationRevealPage>
  );
};


export default ProductTabs;
